const switchMorePhoto = (props) => {
  if (
    props?.result?.room_type_panorama === null ||
    props?.result?.room_type_panorama === undefined
  ) {
    return paramsMorePhotoStyles[0];
  } else {
    return paramsMorePhotoStyles[1];
  }
};

export { switchMorePhoto };

const paramsMorePhotoStyles = [
  {
    bottom: "0",
  },
  {
    bottom: "86px",
  },
];
